
export const environment = {
  production: true,
  gafBaseUrl: 'https://www.freelancer.com',
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
  },
  datastoreConfig: {
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    webSocketUrl: 'https://notifications.freelancer.com'
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
    gitRevision: 'e9c619d8691',
    buildDate: 'Fri Jun 09 2017 06:58:15 GMT-0400 (EDT)'
  },
  billingConfig: {
    baseUrl: 'https://api.flnbln.net',
  },
  facebookAppId: '',
  languageCookie: 'GETAFREE_LANGUAGE'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts